module.exports = __webpack_public_path__ + "img/m-attestation.c7cf28d8.png";